import { InputGroup } from '@blueprintjs/core';
import { Target } from '@retro-ui/api-contract';
import { css } from '@stitches/react';
import { CellContext } from '@tanstack/react-table';
import { ChangeEvent } from 'react';

const nameInputStyle = css({
  fontFamily: 'monospace',
});

interface InputProps {
  cellContext: CellContext<Target, string>;
  onChange: (columnId: string, rowIndex: number, value: string) => void;
}

export function NameInput(props: InputProps) {
  const { cellContext: ctx, onChange } = props;

  const updateName = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(ctx.column.id, ctx.row.index, event.target.value);
  };

  return (
    <InputGroup
      inputClassName={nameInputStyle()}
      data-cy="name-input"
      large
      placeholder="Enter name..."
      defaultValue={ctx.getValue()}
      onBlur={updateName}
    />
  );
}
